<template>
  <div>
    <div class="error input-error" v-if="hasError">{{currentErrorMessage}}</div>
    <div class="input text-input" @click="focusRef" :class="hasValue">
      <input type="text"
             :class="{inputClass, noIcons: !haveIcon}"
             ref="input"
             :placeholder="placeholderAsProp"
             v-model="content"
             v-on:input="updateValue($event.target.value)"
             v-on:keydown="handleKeyDown"
             v-on:keypress="handleKeyPress"
      />
    </div>
  </div>
</template>

<script>
  import baseInput from './mixins/input.class'
  import {initializable} from "./mixins/input.mixin";

  export default {
    extends: baseInput,
    mixins: [initializable],
    name: "text-input",
    props: {
      haveIcon: {
        type: Boolean,
        default: false
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/text-input.vue